import React, { useState, useEffect } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

import FrameL, { Img } from 'component/FrameL';
import Loader from 'component/Loader';

import './style.css';

const MainView = ({ allArticles }) => {
    return <grid-l min="350px">
        {allArticles.map(({ title, image, slug }, i) => {
            return <Link key={i} className="no-underline" to={`/blog/article/${slug}`}>
                <FrameL Image={image} ratio="16:9">
                    <div className="blog-tile__more">
                        <div className="rounded-full bg-white bg-opacity-80 h-24 w-24 flex items-center justify-center">
                            MORE
                        </div>
                    </div>
                </FrameL>
                <h3 className="text-center">{title}</h3>
            </Link>
        })}
    </grid-l>}

const CategoryView = ({ blogCategories, match, setMainTitle }) => {
    const { categorySlug } = match.params;
    const category = blogCategories.find(c => c.slug === categorySlug);

    const { name, articles } = category;

    setMainTitle(name);

    return <grid-l min="350px">
    {articles.map(({ title, image, slug }, i) => {
        return <Link key={i} className="no-underline" to={`/blog/article/${slug}`}>
            <FrameL Image={image} ratio="16:9">
                <div className="blog-tile__more">
                    <div className="rounded-full bg-white bg-opacity-80 h-24 w-24 flex items-center justify-center">
                        MORE
                    </div>
                </div>
            </FrameL>
            <h3 className="text-center">{title}</h3>
        </Link>
    })}
</grid-l>

    // return <stack-l>
    //     {articles.map(({ image, title, content }, i) => {
    //         return <div>
    //             <Img Image={image} />
    //             <h1>{title}</h1>
    //             <ReactMarkdown className="truncate">{content}</ReactMarkdown>
    //         </div>
    //     })}
    // </stack-l>
}

const ArticleView = ({ allArticles = [], match, setMainTitle }) => {
    const { articleSlug } = match.params;
    const article = allArticles.find(article => article.slug === articleSlug);

    const { image, title, content } = article;
    setMainTitle(title);

    return <div className="max-w-screen-lg">
        <Img Image={image} />
        <ReactMarkdown>{content}</ReactMarkdown>
    </div>
}

export default (({ match }) => {
    const [ cmsData, setCmsData ] = useState(null);
    const [ mainTitle, setMainTitle ] = useState("Blog");

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_DOMAIN}/categories`)
        .then(response => response.json())
        .then(blogCategories => {
            const allArticles = blogCategories.reduce((allArticles, { articles }) => {
                allArticles.push(...articles);
                return allArticles;
            }, []).sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));

            setCmsData({ blogCategories, allArticles });
        }).catch(error => {
          // @todo handle error
          console.log('Something went wrong getting blog content');
        });
    }, []);

    if (!cmsData) {
        return <Loader></Loader>
    }

    const { allArticles = [], blogCategories = [] } = cmsData;

    return <div className="xl:container mx-auto px-4 pt-24 lg:pt-16" aria-label="Blog Page" role="main">
        <sidebar-l side="right">
            <div className="border-b border-gray-400 py-8">
                <h1>{mainTitle}</h1>
                <stack-l>
                    {blogCategories.map(({ name, slug }, i) => {
                        return <Link key={i} to={`${match.url}/category/${slug}`} className="text-lg no-underline">{name}</Link>
                    })}
                </stack-l>
            </div>
        </sidebar-l>
        
        <div className="py-8">
            <Switch>
                <Route exact path={`${match.url}/category/:categorySlug`} component={({ match }) => <CategoryView blogCategories={blogCategories} match={match} setMainTitle={setMainTitle} />}></Route>
                <Route exact path={`${match.url}/article/:articleSlug`} component={({ match }) => <ArticleView allArticles={allArticles} match={match} setMainTitle={setMainTitle}/>}></Route>
                <Route path={match.url} component={() => <MainView allArticles={allArticles} />}></Route>
            </Switch>
        </div>
    </div>
        
})